module.exports = __webpack_public_path__ + "static/media/empty-notification.af9c1a1d.png";